import { GlIcon, GlTooltip, GlTruncate } from '@gitlab/ui';
import { getAdaptiveStatusColor } from '~/lib/utils/color_utils';
export default {
    name: 'WorkItemStatusBadge',
    components: {
        GlIcon,
        GlTooltip,
        GlTruncate
    },
    props: {
        item: {
            type: Object,
            required: true,
            validator: (value)=>{
                return typeof value.name === 'string' && typeof value.iconName === 'string' && (value.color === undefined || typeof value.color === 'string') && typeof value.description === 'string' || value.description === null;
            }
        }
    },
    computed: {
        colorStyle () {
            return this.item.color ? {
                color: getAdaptiveStatusColor(this.item.color)
            } : {};
        }
    }
};
